import { useState, useContext } from "react"
import { gql, useQuery } from "@apollo/client"
import { Dropdown } from "primereact/dropdown"
import { LoaderMedium } from "../../components/Loaders"

import _ from "lodash"
import OrganizationLogo from "../../components/OrganizationLogo"

import profileDummy from "../../assets/images/default-profile-avatar.jpg"

// Context
import { UserContext } from "../../context/userContext"

// Queries
const GET_ORGANIZATION = gql`
  query Organization($staff_id: ID!, $organization_id: ID!) {
    organization(staff_id: $staff_id, organization_id: $organization_id) {
      organization_id
      organization_alias
      organization_name
      organization_country
      organization_address
      organization_city
      organization_state
      organization_zip_code
      organization_website
      organization_email_address
      organization_phone_number
      organization_type
      enterprise_id
      organization_admins {
        staff_id
        staff_alias
        staff_name_first
        staff_name_last
        staff_email_address
      }
      organization_programs
    }
    organizations: organizationsByUid(staff_id: $staff_id) {
      organization_id
      organization_alias
      organization_name
      enterprise_id
    }
  }
`

export default function SidebarActivityLog() {
  const userCtx = useContext(UserContext)
  const [selectedOrganization, setSelectedOrganization] = useState(null)
  const [availableOrganization, setAvailableOrganizations] = useState(null)

  const { data, loading } = useQuery(GET_ORGANIZATION, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: !_.isNull(selectedOrganization)
        ? selectedOrganization.code
        : userCtx.session.user.organization_id,
    },
    context: {
      headers: {
        //user: JSON.stringify(user),
      },
    },
    skip: !userCtx.session.user.staff_id,
    fetchPolicy: "network-only",
    onCompleted: ({ organizations }) => {
      const organizationsList = _.map(organizations, (org) => {
        return {
          name: org.organization_name,
          code: org.organization_id,
        }
      })

      return setAvailableOrganizations(organizationsList)
    },
  })

  const onOrganizationChange = (e) => {
    userCtx.setStaff(userCtx.session.user.staff_id, e.value.code)
    setSelectedOrganization(e.value)
  }

  if (loading) return <LoaderMedium />

  return (
    <div>
      <OrganizationLogo></OrganizationLogo>
      <Dropdown
        value={selectedOrganization}
        options={availableOrganization}
        onChange={onOrganizationChange}
        optionLabel="name"
        placeholder="Select an Organization"
        className="organization-select"
      />
      <div className="organization-container">
        <p>
          <strong>Organization Name:</strong>
          {` ${data?.organization?.organization_name}`}
        </p>
        <p>
          <strong>Organization ID:</strong>
          {` ${data?.organization?.organization_alias}`}
        </p>
        <p>
          <strong>Address:</strong>
          {` ${data?.organization?.organization_address}`}
        </p>
        <p>
          <strong>Email:</strong>
          {` ${data?.organization?.organization_email_address}`}
        </p>
        <p>
          <strong>Phone:</strong>
          {` ${data?.organization?.organization_phone_number}`}
        </p>
        <p>
          <strong>Program ID(s) Name:</strong>
          {!_.isEmpty(data?.organization?.organization_programs)
            ? data?.organization?.organization_programs.replace(",", ", ")
            : "Not available"}
        </p>
        <p>
          <strong>Organizational Administrators:</strong>
        </p>

        {_.map(data?.organization?.organization_admins, (admin) => {
          return (
            <div key={admin.staff_alias} className="organizator-container">
              <div className="organizator-picture">
                <img
                  src={profileDummy}
                  className="border-2 border-white rounded-full w-11 h-11"
                  alt="profile"
                />
              </div>
              <div className="organizator-info">
                <strong>{`${admin?.staff_name_first} ${admin?.staff_name_last}`}</strong>
                <br></br>
                <span>{`${admin?.staff_email_address}`}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
